import React from "react";
import { Grid, Typography, Box } from "@mui/material";
import { MetricCard } from "../Style/health-chart.style";
import { HomeHeader } from "../../../chartsJSON/data";
import { useNavigate } from "react-router-dom";

export default function MetricCards({ summaryData, districts }) {
    const navigate = useNavigate();

    const handleCardClick = () => {
        navigate('/area-wise-data');
    };
    return (
        <Grid container spacing={4} sx={{ mb: 3, justifyContent: 'center' }}>
            {HomeHeader?.map((item, index) => {
                return (
                <Grid item key={index}>
                    <Box
                        component="div"
                        onClick={() => handleCardClick()}
                        sx={{
                            height: '100%',
                            '&:hover': {
                                cursor: 'pointer',
                                '& .MuiPaper-root': {
                                    boxShadow: 3,
                                    transform: 'translateY(-2px)',
                                    transition: 'all 0.2s ease-in-out'
                                }
                            }
                        }}
                    >
                        <MetricCard
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'space-between',
                                height: '110px',
                                width: '250px',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease-in-out',
                            }}
                        >
                    <Typography
                        variant="caption"
                        sx={{
                            fontSize: "12px",
                            display: "block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "normal",
                            fontWeight: "bold",
                            color: "black"
                        }}
                    >
                        {item?.label}
                    </Typography>

                    <Typography
                        variant="h6"
                        color="primary"
                        sx={{ fontWeight: "bold", mt: 'auto' }}
                    >
                        {(() => {
                            switch (item.key) {
                                case 'total_population_screened':
                                    return summaryData.count_screenings || 0;
                                case 'villages_screening_started':
				    //return summaryData.count_villages || 0;
					return 1396;
                                case 'health_facility_screening_started':
                                    //return summaryData.count_hfn || 0;
					return 248;
                                case 'districts_covered':
                                    return districts.length > 1 ? districts.length : 0;
                                default:
                                    return 0;
                            }
                        })()}
                        </Typography>
                    </MetricCard>
                    </Box>
                </Grid>
            )})}
        </Grid>
    );
}
